// See https://docs.mapbox.com/mapbox-gl-js/style-spec/layers/ for more details

import { AreaRating } from 'const/AreaRating';
import { MapZonesOverlay } from 'const/Map/MapZonesOverlay';

const fills = {
  id: MapZonesOverlay.FillLayerId,
  type: 'fill',
  source: MapZonesOverlay.SourceId,
  layout: {},
  paint: {
    'fill-color': [
      'match',
      ['coalesce', ['feature-state', 'rating'], ['feature-state', 'partition']],
      AreaRating.LIKE,
      '#4caf50',
      AreaRating.DISLIKE,
      '#e91e63',

      /**
       * Note :
       * Colors used in here based on `dispatch-frontend/src/pages/partitions/PartitionList/PartitionList.tsx`
       */
      '1',
      '#ab47bc', // purple 400
      '2',
      '#42a5f5', // blue 400
      '3',
      '#ffa726', // orange 400
      '4',
      '#8d6e63', // brown 400
      '5',
      '#ff7043', // deep-orange 400
      '6',
      '#5c6bc0', // indigo 400
      '7',
      '#26c6da', // cyan 400
      '8',
      '#ffca28', // amber 400
      '9',
      '#9c27b0', // purple 500
      '10',
      '#2196f3', // blue 500
      '11',
      '#ff9800', // orange 500
      '12',
      '#795548', // brown 500
      '13',
      '#ff5722', // deep-orange 500
      '14',
      '#3f51b5', // indigo 500
      '15',
      '#00bcd4', // cyan 500
      '16',
      '#ffc107', // amber 500

      'darkgray',
    ],
    'fill-opacity': [
      'case',
      ['boolean', ['feature-state', 'hover'], false],
      0.8,
      0.5,
    ],
  },
};

const borders = {
  id: MapZonesOverlay.BorderLayerId,
  type: 'line',
  source: MapZonesOverlay.SourceId,
  layout: {},
  paint: {
    'line-color': 'black',
    'line-width': [
      'match',
      ['feature-state', 'rating'],
      'LIKE',
      2,
      'DISLIKE',
      2,

      0.5,
    ],
  },
};

const labels = {
  id: MapZonesOverlay.LabelLayerId,
  type: 'symbol',
  source: MapZonesOverlay.SourceId,
  layout: {
    'text-field': '{count}',
    'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
    'text-size': 20,
  },
};

export const PartitionsAreaLayers = {
  fills,
  borders,
  labels,
};
